import { useMultiDialog } from '@/components/multiDialogsProvider'
import { computed, markRaw } from 'vue'
import { useI18n } from 'vue-i18n'
import { useGroupStore } from '@/store/group'
import { useMessage } from 'naive-ui'

// 判断是否登录
import { useUserStore } from '@/store/user'
import { ACCOUNT } from '@plus/env'
import useTeamShare from '@teams/common/hooks/useTeamShare'
import { ForbiddenJoin, JoinTeam } from '@/components/multiDialogsContent'

export const useJoinTeamDialog = () => {
  const commonDialog = useMultiDialog()
  const { inviteInfo, joinTeam, joinTeamByKey, settingInfo } = useTeamShare()
  const groupStore = useGroupStore()
  const message = useMessage()

  const { t } = useI18n()
  // eslint-disable-next-line
  const $joinTeam = (key: string, ...params: any[]) => {
    // @ts-ignore
    return t(`components.dialog.joinTeam.${key}`, ...params)
  }
  const $forbiddenJoin = (key: string, ...params: any[]) => {
    // @ts-ignore
    return t(`components.dialog.forbiddenJoin.${key}`, ...params)
  }
  const needApprove = computed(() => {
    return settingInfo.value.share_need_approve
  })

  const join = async function () {
    // 判断是否登录
    const userStore = useUserStore()
    if (!userStore.userId) {
      const inviteUrl = inviteInfo.value?.invite_url
      const cbUrl =
        groupStore.isFromInviteUrl && inviteUrl ? inviteUrl : location.href
      window.location.href = `${ACCOUNT}?cb=${cbUrl}`
      return
    }
    const invKey = inviteInfo.value?.invite_link?.key
    const { id: groupId } = groupStore.current
    try {
      // 根据有无邀请key（有可以为分享落地页）使用不同加入团队接口
      if (invKey) {
        await joinTeamByKey(invKey)
      } else {
        await joinTeam()
      }
      if (needApprove.value) {
        message.success($joinTeam('apply'), { duration: 3000 })
      } else {
        message.success($joinTeam('joinSuccess'))
        setTimeout(() => {
          const url = location.origin + `/${groupId}`
          window.location.href = url
        }, 3000)
      }
      commonDialog.close()
    } catch (e: any) {
      const msg = e?.response?.data?.msg
      const result = e?.response?.data?.result
      if (['joinGroupWaitingApprove'].includes(result)) {
        message.success($joinTeam('apply'), { duration: 3000 })
        return
      }
      // 如果添加成员时抛出UserNotInCompany错误，则是企业外部人员，弹出当前空间仅支持企业成员申请的弹框，可以选择切换账号
      if (result === 'UserNotInCompany') {
        showForbiddenJoin()
        return
      }
      msg && message.error(msg, { duration: 3000 })
    }
  }

  // 显示申请加入团队弹框
  const showApplyJoinDialog = () =>
    new Promise(() => {
      commonDialog.show({
        name: 'common',
        componentKey: 'appealJoinTeam',
        componentProps: {
          title: $joinTeam('title'),
          size: 'small',
          className: 'join-team-dialog',
          dialogContent: markRaw(JoinTeam),
          onOk: async () => {
            await join().catch()
          }
        }
      })
    })

  const showForbiddenJoin = () =>
    new Promise(() => {
      commonDialog.show({
        name: 'common',
        componentKey: 'forbiddenJoinTeam',
        componentProps: {
          title: $forbiddenJoin('title'),
          size: 'small',
          className: 'join-team-dialog',
          footer: false,
          dialogContent: markRaw(ForbiddenJoin),
          dialogContentProps: {
            avatar: groupStore.current.companyLogo,
            companyName: groupStore.current.companyName,
            onCancel: () => {
              commonDialog.close()
            }
          }
        }
      })
    })

  const start = async () => {
    await showApplyJoinDialog()
  }

  return start
}
